import AdSchedule from '../../../views/AdSchedule.vue'
import AdResources from '../../../views/AdResources.vue'
import AdCampaignList from '../../../views/AdCampaignList.vue'
import AdTrackingReport from '../../../views/AdTrackingReport.vue'
import { createAppRouter } from '../../../router/createRouter'

export const adsRoutes = [
  {
    path: '/AdCampaignList',
    name: 'AdCampaignList',
    component: AdCampaignList,
    meta: { requiresAuth: true }
  },
  {
    path: '/AdSchedule',
    name: 'AdSchedule',
    component: AdSchedule,
    meta: { requiresAuth: true }
  },
  {
    path: '/AdResources',
    name: 'AdResources',
    component: AdResources,
    meta: { requiresAuth: true }
  },
  {
    path: '/AdTrackingReport',
    name: 'AdTrackingReport',
    component: AdTrackingReport,
    meta: { requiresAuth: true }
  }
]

const router = createAppRouter({
  productRoutes: adsRoutes,
  defaultAuthenticatedRoute: '/AdCampaignList'
})

export default router
